import React from 'react'
import PropTypes from 'prop-types'

import Button from 'components/Button'
import Link from 'components/Link'
import { Eyebrow, Title60, Title26, Title20 } from 'components/Typography'
import theme from 'styles/theme'
import trackGTM from 'utils/trackGTM'
import GA4 from 'utils/GA4'

import { Conditions, TimeRow, Times, Wrapper } from './OpeningTimes.style'

function OpeningTimes({
  conditionsCopy,
  maxWidth,
  openingTimesLink,
  openingTimesLinkLabel,
  times,
  title,
  isModal,
  villageName,
  hideLine,
}) {
  return (
    <Wrapper maxWidth={maxWidth} isModal={isModal} hideLine={hideLine}>
      {isModal ? (
        <Title26 textAlign={['center']}>{title}</Title26>
      ) : (
        <Title60 as="h4" textAlign={['center']}>
          {title}
        </Title60>
      )}

      <Times isModal={isModal}>
        {times.map(({ date, day, openTimes, isCurrentDay }) => (
          <li key={`${date}_${day}`}>
            {!isModal && <Eyebrow mb={[theme.space[1]]}>{date}</Eyebrow>}
            <TimeRow>
              <Title20 fontWeight={[isCurrentDay === true ? `bold` : `normal`]}>
                {day}
              </Title20>
              <Title20
                as="span"
                fontWeight={[isCurrentDay === true ? `bold` : `normal`]}>
                {openTimes}
              </Title20>
            </TimeRow>
          </li>
        ))}
      </Times>
      {isModal && openingTimesLink && openingTimesLinkLabel && (
        <Button
          onClick={() => {
            trackGTM(
              'accordion interaction',
              'accordion interaction',
              'opening hours',
              openingTimesLinkLabel
            )
            GA4('see_more_hours', { village_name: villageName })
          }}
          as={Link}
          mt={[theme.space[6]]}
          width={['100%', null, 'inherit']}
          to={openingTimesLink}
          fixedSize>
          {openingTimesLinkLabel}
        </Button>
      )}
      {conditionsCopy && (
        <Conditions isModal={isModal}>{`*${conditionsCopy}`}</Conditions>
      )}
    </Wrapper>
  )
}

OpeningTimes.propTypes = {
  conditionsCopy: PropTypes.string,
  maxWidth: PropTypes.arrayOf(PropTypes.string),
  openingTimesLink: PropTypes.string,
  openingTimesLinkLabel: PropTypes.string,
  times: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  title: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
  villageName: PropTypes.string,
  hideLine: PropTypes.bool,
}

OpeningTimes.defaultProps = {
  conditionsCopy: null,
  maxWidth: null,
  openingTimesLink: null,
  openingTimesLinkLabel: null,
  isModal: false,
  villageName: '',
  hideLine: false,
}

export default OpeningTimes
